// @flow
import { GET_USER_DETAILS } from "./actionTypes";

export default () => ({
  type: GET_USER_DETAILS,
  payload: {
  
  }
});